import React from "react";
import { Modal, Button } from "react-bootstrap";
import Calendar from "react-calendar";
import {
  URL_HELPER,
  COMPETITION_SUPPORTED_WORD_LENGTHS,
  CREATE_COMP_STATES,
  CREATE_COMP_STATES_ARRAY,
  COMPETITION_THEME_SCRABBLE,
  COMPETITION_THEME_POKEMON,
  COMPETITION_THEME_COUNTRIES
} from "../utils/constants";
import { createCompetition } from "../https_handler/apiHandler";
import Spinner from "./Spinner";

import { DateTime } from "luxon";

import { BsInfoCircle } from "react-icons/bs";

import "react-calendar/dist/Calendar.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "./SharedModal.css";

const CreateCompModel = ({ show, handleClose, user, showErrorModal }) => {
  const [isLoading, setLoading] = React.useState(false);

  const [inputTitle, setTitle] = React.useState("");
  const [inputMaxGuesses, setGuesses] = React.useState(5);
  const [inputWordLengths, setInputWordLengths] = React.useState(["5"]);

  const [endDateValue, endDateValueChange] = React.useState();
  const [startDateValue, startDateValueChange] = React.useState();
  const [compType, changeCompType] = React.useState();
  const [compDifficulty, setCompDifficulty] = React.useState("medium");
  const [compDifficultyText, setCompDifficultyText] = React.useState();
  const [showCompDifficultyModal, setShowCompDifficultyModal] = React.useState(false);
  const [modalState, setModalState] = React.useState(0);

  const handleCreateComp = async () => {

    if (isLoading) return;
    setLoading(true);

    const { jumbled, restrictGuesses } = getCompDifficulty();
    const response = await createCompetition(user, inputTitle, inputMaxGuesses, inputWordLengths.join(","), formatDateString(endDateValue), formatDateString(startDateValue), compType, { jumbled, restrictGuesses });

    if (response.error) {
      showErrorModal(response.error);
      setLoading(false);
      return;
    }

    const baseUrl = window.location.href.split("/")[0];
    window.location.href = `${baseUrl}/${URL_HELPER.URL_COMPETITION_PARAM}${response.compId}`;

    setLoading(false);
    handleClose();
  }

  const getCompDifficulty = () => {
    const jumbled = compDifficulty === "easy" ? true : false;

    const restrictGuesses = compDifficulty === "hard" ? true : false;

    return { jumbled, restrictGuesses }
  }

  const formatDateString = (date) => {
    if (!date) return;

    return DateTime.fromISO(date.toISOString()).toISO();
  }

  const handleCalenderChange = (values) => {
    formatDateString(values[0])
    startDateValueChange(values[0]);
    endDateValueChange(values[1]);
  }

  const handleBackButton = () => {
    if (modalState === 0) return hideModal();
    let pagesToJump = 1;

    if (CREATE_COMP_STATES_ARRAY[modalState] === CREATE_COMP_STATES.STATE_DIFFICULTY) pagesToJump = 2;

    setModalState(modalState - pagesToJump);
  }

  const handleNextButton = () => {
    if (validateStageInput() === false) return;

    if (modalState === CREATE_COMP_STATES_ARRAY.length - 1) return handleCreateComp();

    setModalState(modalState + 1);
  }

  const validateStageInput = () => {
    if (CREATE_COMP_STATES_ARRAY[modalState] === CREATE_COMP_STATES.STATE_TITLE) return validateStateTitle();

    if (CREATE_COMP_STATES_ARRAY[modalState] === CREATE_COMP_STATES.STATE_GUESSES) return validateStateGuesses();

    if (CREATE_COMP_STATES_ARRAY[modalState] === CREATE_COMP_STATES.STATE_TYPE) return validateStateType();

    if (CREATE_COMP_STATES_ARRAY[modalState] === CREATE_COMP_STATES.STATE_DATE_RANGE) return validateStateDateRange();
  }
  const validateStateTitle = () => {
    if (!inputTitle || inputTitle === "") {
      showErrorModal("You are missing something, we need to know what to call your competition!");
      return false;
    }
    return true;
  }

  const validateStateGuesses = () => {
    if (!inputMaxGuesses || parseInt(inputMaxGuesses) <= 0) {
      showErrorModal("Missing required input, how many attempts should users be restricted to per word?");
      return false;
    }
  }
  const validateStateDateRange = () => {
    if (!endDateValue) {
      showErrorModal("Missing required input, you need to specify the dates in which the competition should start and finish");
      return false;
    }
    return true;
  }

  const validateStateType = () => {
    if (!compType) {
      showErrorModal("Missing required input, what kind of competition is this?");
      return false;
    }
    return true;
  }

  const hideModal = () => {
    setModalState(0);
    setTitle("");
    setGuesses(5);
    setInputWordLengths(["5"]);
    endDateValueChange();
    startDateValueChange();
    changeCompType();
    setCompDifficulty("medium");

    if (!isLoading)
      handleClose();
  }

  const handleChangeCompType = (event) => {
    changeCompType(event.target.value)
  }

  const handleChangeCompDifficulty = (event) => {
    setCompDifficulty(event.target.value)
  }

  const handleWordLengthRadioChange = (event) => {
    const inputWordLength = event.target.value;

    if (inputWordLengths.includes(inputWordLength)) {
      if (inputWordLengths.length === 1) return;

      const wordLengths = inputWordLengths.filter(wordLength => wordLength !== inputWordLength)
      setInputWordLengths(wordLengths);
      return;
    }

    const wordLengths = [...inputWordLengths, inputWordLength];

    if (wordLengths.length > 2) wordLengths.shift();

    setInputWordLengths(wordLengths);
  }

  const getCompDifficultyText = () => {
    if (compDifficultyText === "Easy") return "A jumbled version of the word will be presented to the user as a hint.";
    if (compDifficultyText === "Medium") return "No hints and all valid words can be used as guesses.";
    if (compDifficultyText === "Hard") return "No hints and only words relating to the selected theme can be used as guesses e.g. If the countries theme is selected users can only attempt guesses using valid country names and not generic words.";
  }

  const showDifficultyModal = (compDifficulty) => {
    setCompDifficultyText(compDifficulty)
    setShowCompDifficultyModal(true);
  }

  const hideDifficultyModal = () => {
    setShowCompDifficultyModal(false);
  }



  const renderStateTitle = () => {
    return <Modal
      size="lg"
      centered
      show={show}
      onHide={hideModal}
      className="custom-modal"
    >
      <Modal.Header closeButton>
        <h2 className="modal-heading">Create Competition</h2>
      </Modal.Header>
      <Modal.Body>
        <div className="modal-form-group">
          <label className="modal-label" htmlFor="competition-title">
            Competition Title
          </label>
          <input 
            id="competition-title"
            className="modal-input" 
            type="text"
            value={inputTitle} 
            onChange={(event) => setTitle(event.target.value)}
            placeholder="Enter competition title..."
          />
          <p className="modal-text" style={{ fontSize: '0.875rem', color: 'var(--gray-600)' }}>
            Choose a descriptive name for your competition that participants will easily recognize.
          </p>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button className="modal-btn secondary" onClick={handleBackButton}>
          Cancel
        </button>
        <button className="modal-btn primary" onClick={handleNextButton}>
          Next
        </button>
      </Modal.Footer>
    </Modal>
  }

  const renderStateGuesses = () => {
    return <Modal
      size="lg"
      centered
      show={show}
      onHide={hideModal}
      className="custom-modal"
    >
      <Modal.Header closeButton>
        <h2 className="modal-heading">Competition: {inputTitle}</h2>
      </Modal.Header>
      <Modal.Body>
        <div className="modal-form-group">
          <label className="modal-label" htmlFor="max-guesses">
            Maximum Guesses Per Word
          </label>
          <input 
            id="max-guesses"
            className="modal-input" 
            type="number" 
            min="1"
            max="10"
            value={inputMaxGuesses} 
            onChange={(event) => setGuesses(event.target.value)}
          />
          <p className="modal-text" style={{ fontSize: '0.875rem', color: 'var(--gray-600)' }}>
            How many attempts should players have to guess each word correctly? Recommended: 5-6 attempts.
          </p>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button className="modal-btn secondary" onClick={handleBackButton}>
          Back
        </button>
        <button className="modal-btn primary" onClick={handleNextButton}>
          Next
        </button>
      </Modal.Footer>
    </Modal>
  }

  const renderStateWordLength = () => {
    if (compType !== COMPETITION_THEME_SCRABBLE) return handleNextButton();

    return <Modal
      size="lg"
      centered
      show={show}
      onHide={hideModal}
      className="custom-modal"
    >
      <Modal.Header closeButton>
        <h2 className="modal-heading">Competition: {inputTitle}</h2>
      </Modal.Header>
      <Modal.Body>
        <div className="modal-form-group">
          <label className="modal-label">Word Lengths</label>
          <p className="modal-text" style={{ fontSize: '0.875rem', color: 'var(--gray-600)', marginBottom: 'var(--space-lg)' }}>
            Select the length(s) of words for your competition. You can choose up to two different lengths.
          </p>
          
          <div className="modal-radio-group">
            {COMPETITION_SUPPORTED_WORD_LENGTHS.map(wordLength => (
              <div 
                key={wordLength}
                className={`modal-radio-item ${inputWordLengths.includes(wordLength) ? 'selected' : ''}`}
                onClick={(e) => {
                  e.preventDefault();
                  handleWordLengthRadioChange({ target: { value: wordLength } });
                }}
              >
                <input
                  type="checkbox"
                  value={wordLength}
                  checked={inputWordLengths.includes(wordLength)}
                  onChange={() => {}}
                />
                <label>{wordLength} letters</label>
              </div>
            ))}
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button className="modal-btn secondary" onClick={handleBackButton}>
          Back
        </button>
        <button className="modal-btn primary" onClick={handleNextButton}>
          Next
        </button>
      </Modal.Footer>
    </Modal>
  }
  const renderStateType = () => {
    return <Modal
      size="lg"
      centered
      show={show}
      onHide={hideModal}
      className="custom-modal"
    >
      <Modal.Header closeButton>
        <h2 className="modal-heading">Competition: {inputTitle}</h2>
      </Modal.Header>
      <Modal.Body>
        <div className="modal-form-group">
          <label className="modal-label">Competition Theme</label>
          <p className="modal-text" style={{ fontSize: '0.875rem', color: 'var(--gray-600)', marginBottom: 'var(--space-lg)' }}>
            Choose a theme for your competition. Themed competitions include words related to a specific topic.
          </p>
          
          <div className="modal-radio-group">
            <div 
              className={`modal-radio-item ${compType === COMPETITION_THEME_SCRABBLE ? 'selected' : ''}`}
              onClick={() => changeCompType(COMPETITION_THEME_SCRABBLE)}
            >
              <input
                type="radio"
                value={COMPETITION_THEME_SCRABBLE}
                checked={compType === COMPETITION_THEME_SCRABBLE}
                onChange={handleChangeCompType}
                name="compType"
              />
              <label>Scrabble</label>
            </div>

            <div 
              className={`modal-radio-item ${compType === COMPETITION_THEME_POKEMON ? 'selected' : ''}`}
              onClick={() => changeCompType(COMPETITION_THEME_POKEMON)}
            >
              <input
                type="radio"
                value={COMPETITION_THEME_POKEMON}
                checked={compType === COMPETITION_THEME_POKEMON}
                onChange={handleChangeCompType}
                name="compType"
              />
              <label>Pokémon</label>
            </div>

            <div 
              className={`modal-radio-item ${compType === COMPETITION_THEME_COUNTRIES ? 'selected' : ''}`}
              onClick={() => changeCompType(COMPETITION_THEME_COUNTRIES)}
            >
              <input
                type="radio"
                value={COMPETITION_THEME_COUNTRIES}
                checked={compType === COMPETITION_THEME_COUNTRIES}
                onChange={handleChangeCompType}
                name="compType"
              />
              <label>Countries</label>
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button className="modal-btn secondary" onClick={handleBackButton}>
          Back
        </button>
        <button className="modal-btn primary" onClick={handleNextButton}>
          Next
        </button>
      </Modal.Footer>
    </Modal>
  }

  const renderStateDateRange = () => {
    return <Modal
      size="lg"
      centered
      show={show}
      onHide={hideModal}
      className="custom-modal"
    >
      <Modal.Header closeButton>
        <h2 className="modal-heading">Competition: {inputTitle}</h2>
      </Modal.Header>
      <Modal.Body>
        {isLoading && (
          <div className="loading-overlay">
            <Spinner />
          </div>
        )}
        
        <div className="modal-form-group">
          <label className="modal-label">Competition Duration</label>
          <p className="modal-text" style={{ fontSize: '0.875rem', color: 'var(--gray-600)', marginBottom: 'var(--space-lg)' }}>
            Select the date range for your competition. Click and drag to select a range, or click a single date for a one-day competition.
          </p>
          
          <div className="modal-calendar-container">
            <Calendar
              className="modal-calendar"
              onChange={handleCalenderChange}
              returnValue={"range"}
              selectRange={true}
              value={[startDateValue, endDateValue]}
              minDate={new Date(Date.now())}
            />
          </div>
          
          {startDateValue && endDateValue && (
            <div className="modal-info-box">
              <BsInfoCircle className="info-icon" />
              <p className="modal-info-text">
                Competition will run from {startDateValue.toLocaleDateString()} to {endDateValue.toLocaleDateString()}
              </p>
            </div>
          )}
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button className="modal-btn secondary" onClick={handleBackButton}>
          Back
        </button>
        <button className="modal-btn primary" onClick={handleNextButton}>
          Next
        </button>
      </Modal.Footer>
    </Modal>
  }

  const renderStateDifficulty = () => {
    return <Modal
      size="lg"
      centered
      show={show}
      onHide={hideModal}
      className="custom-modal"
    >
      <Modal.Header closeButton>
        <h2 className="modal-heading">Competition: {inputTitle}</h2>
      </Modal.Header>
      <Modal.Body>
        <div className="modal-form-group">
          <label className="modal-label">Difficulty Level</label>
          <p className="modal-text" style={{ fontSize: '0.875rem', color: 'var(--gray-600)', marginBottom: 'var(--space-lg)' }}>
            Choose the difficulty level for your competition. Click the info icons to learn more about each level.
          </p>
          
          <div className="modal-radio-group">
            <div 
              className={`modal-radio-item ${compDifficulty === 'easy' ? 'selected' : ''}`}
              onClick={() => setCompDifficulty('easy')}
            >
              <input
                type="radio"
                value="easy"
                checked={compDifficulty === 'easy'}
                onChange={handleChangeCompDifficulty}
                name="compDifficulty"
              />
              <label>Easy</label>
              <BsInfoCircle 
                style={{ marginLeft: 'auto', cursor: 'pointer', color: 'var(--secondary-blue)' }}
                onClick={(e) => {
                  e.stopPropagation();
                  showDifficultyModal("Easy");
                }}
              />
            </div>

            <div 
              className={`modal-radio-item ${compDifficulty === 'medium' ? 'selected' : ''}`}
              onClick={() => setCompDifficulty('medium')}
            >
              <input
                type="radio"
                value="medium"
                checked={compDifficulty === 'medium'}
                onChange={handleChangeCompDifficulty}
                name="compDifficulty"
              />
              <label>Medium</label>
              <BsInfoCircle 
                style={{ marginLeft: 'auto', cursor: 'pointer', color: 'var(--secondary-blue)' }}
                onClick={(e) => {
                  e.stopPropagation();
                  showDifficultyModal("Medium");
                }}
              />
            </div>

            <div 
              className={`modal-radio-item ${compDifficulty === 'hard' ? 'selected' : ''}`}
              onClick={() => setCompDifficulty('hard')}
            >
              <input
                type="radio"
                value="hard"
                checked={compDifficulty === 'hard'}
                onChange={handleChangeCompDifficulty}
                name="compDifficulty"
              />
              <label>Hard</label>
              <BsInfoCircle 
                style={{ marginLeft: 'auto', cursor: 'pointer', color: 'var(--secondary-blue)' }}
                onClick={(e) => {
                  e.stopPropagation();
                  showDifficultyModal("Hard");
                }}
              />
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button className="modal-btn secondary" onClick={handleBackButton}>
          Back
        </button>
        <button 
          className="modal-btn primary" 
          onClick={handleNextButton}
          disabled={isLoading}
        >
          {isLoading ? (
            <span className="modal-loading">
              <span>Creating...</span>
            </span>
          ) : (
            'Create Competition'
          )}
        </button>
      </Modal.Footer>
    </Modal>
  }

  const renderModal = () => {
    if (CREATE_COMP_STATES_ARRAY[modalState] === CREATE_COMP_STATES.STATE_TITLE) return renderStateTitle();

    if (CREATE_COMP_STATES_ARRAY[modalState] === CREATE_COMP_STATES.STATE_WORD_LENGTH) return renderStateWordLength();

    if (CREATE_COMP_STATES_ARRAY[modalState] === CREATE_COMP_STATES.STATE_DIFFICULTY) return renderStateDifficulty();

    if (CREATE_COMP_STATES_ARRAY[modalState] === CREATE_COMP_STATES.STATE_TYPE) return renderStateType();

    if (CREATE_COMP_STATES_ARRAY[modalState] === CREATE_COMP_STATES.STATE_GUESSES) return renderStateGuesses();

    if (CREATE_COMP_STATES_ARRAY[modalState] === CREATE_COMP_STATES.STATE_DATE_RANGE) return renderStateDateRange();
  }

  return (
    <>
      {
        renderModal()
      }

      <Modal
        size="lg"
        centered
        show={showCompDifficultyModal}
        onHide={hideDifficultyModal}
        className="custom-modal"
      >
        <Modal.Header closeButton>
          <h2 className="modal-heading">Difficulty: {compDifficultyText}</h2>
        </Modal.Header>
        <Modal.Body>
          <div className="modal-form-group">
            <p className="modal-text">{getCompDifficultyText()}</p>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button className="modal-btn primary" onClick={hideDifficultyModal}>
            Got it!
          </button>
        </Modal.Footer>
      </Modal>
    </>
  )
}

export default CreateCompModel;